import { Injectable, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { Notification } from 'src/app/shared/models/shared/notifications/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  alertStatus: BehaviorSubject<Notification> = new BehaviorSubject<Notification>({
    content: 'testing',
    state: 'info',
    type: 0,
    show: false,
  });

  constructor(private toaster: ToastrService) {}

  publishMessages(content: string, state: string): void {
    this.alertStatus.next({ content, state, type: 0, show: true });
    setTimeout(() => {
      this.dismissMessage();
    }, 5000);
  }

  dismissMessage(): void {
    this.alertStatus.next({ content: '', state: '', type: 0, show: false });
  }

  displaySuccess(message: string, title?: string) {
    this.toaster.success(message, title);
  }

  displayError(message: string, title?: string) {
    if (this.toaster.currentlyActive) {
      this.toaster.clear();
    }
    this.toaster.error(message, title);
  }
}
